import { render, staticRenderFns } from "./icon-svg.vue?vue&type=template&id=75843509&"
import script from "./icon-svg.vue?vue&type=script&lang=js&"
export * from "./icon-svg.vue?vue&type=script&lang=js&"
import style0 from "./icon-svg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports